if (window.innerWidth > 750) {
    document.addEventListener('DOMContentLoaded', () => {
        const megaMenu = document.querySelector('ul[data-menu-list-id="MegaMenuList-1"]');
        
        if (!megaMenu) return;
        
        const seriesList = megaMenu.querySelector('.custom-series-list ul');
        const productsContainer = megaMenu.querySelector('.custom-series-products');
        
        if (!seriesList || !productsContainer) return;
        
        const seriesItems = seriesList.querySelectorAll('li');
        const productLists = productsContainer.querySelectorAll('.custom-products');
        
        let hoverTimeout = null;
        
        seriesItems.forEach((item, index) => {
            item.addEventListener('mouseenter', () => {
                clearTimeout(hoverTimeout);
                productLists.forEach(list => list.classList.remove('is-visible'));
                if (productLists[index]) {
                    productLists[index].classList.add('is-visible');
                }
            });
        });
        
        seriesList.addEventListener('mouseleave', () => {
            hoverTimeout = setTimeout(() => {
                if (!productsContainer.matches(':hover')) {
                    productLists.forEach(list => list.classList.remove('is-visible'));
                }
            }, 100);
        });
        
        productsContainer.addEventListener('mouseenter', () => {
            clearTimeout(hoverTimeout);
        });
        
        productsContainer.addEventListener('mouseleave', () => {
            productLists.forEach(list => list.classList.remove('is-visible'));
        });
    });
}